import { createPortal } from "react-dom";
import { Route, Router } from "react-router-dom";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";
import { useState, useEffect } from "react";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import headphone from "assets/images/headphone.png";
import l1 from "assets/images/Logos/Group 22.png";
import laptop from "assets/images/laptop.png";
import sendRequest from "hooks/useAxios";
import sendRequest2 from "hooks/useAxios2";
import Creatable from "react-select/creatable";
import sendRequestUsers from "hooks/useAxios";
import toast from "react-hot-toast";

export default function UpdateRepairModal({
  selectedItem,
  updateSelectedItem,
  orderUpdater
}) {
  const [addModalData, setAddModalData] = useState({
    userName: "",
    phone: "",
    Price: "",
    sendtm: "",
    send_trackingcode: "",
    debtAmount: "",
    description: "",
    Discount: "",
    choseFile: "",
    paid_amount: "",
    DeviceName: "",
    PriceSingleProduct: "",
    user_muid: "",
    rescipient_mobile: "",
    rescipient_fname: "",
    rescipient_lname: "",
    rescipient_address: "",
    rescipient_postalcode: "",
    addDevice: []
  });
  // console.log("addmodalDD:", addModalData);
  const [userOption, setUserOption] = useState([
    // { value: "0", label: "arefe", phoneNumber: "09305382470" },
    // { value: "1", label: "maryam", phoneNumber: "09211702120" },
    // { value: "2", label: "zahra", phoneNumber: "091239803636" },
  ]);
  const [deletedOrderId, setDeletedOrderId] = useState([]);
  const [staticImg, setStaticImg] = useState({ imgl1: l1 });
  const [newUser, setNewUser] = useState({ fName: "", lName: "", mobile: "" });
  const [displayStatus, setDisplayStatus] = useState("d-none");

  useEffect(() => {
    sendRequestUsers("Find_users").then(({ data }) => {
      setUserOption([
        { value: "create", label: "کاربر جدید" },
        ...data.map(value => {
          return {
            value: value.id,
            label: value.fname + " " + value.lname,
            phoneNumber: value.mobile
          };
          // ...data,
        })
      ]);
    });
  }, []);
  const changeHandler = (value, type) => {
    setAddModalData(prev => {
      return { ...prev, [type]: value };
    });
  };
  console.log("deletedOrderId", deletedOrderId);
  const sendAddModalData = () => {
    let fd = new FormData();
    console.log(addModalData);
    fd.append("order_id", addModalData.id);
    //  fd.append("muid", addModalData.muid);
    fd.append("send_trackingcode", addModalData.send_trackingcode);
    // fd.append("description", addModalData.description);
    fd.append("rescipient_fname", addModalData.rescipient_fname);
    fd.append("rescipient_lname", addModalData.rescipient_lname);
    fd.append("rescipient_mobile", addModalData.rescipient_mobile);
    fd.append("rescipient_postalcode", addModalData.rescipient_postalcode);
    fd.append("rescipient_address", addModalData.rescipient_address);
    fd.append("paid_amount", addModalData.paid_amount);
    fd.append("sendtm", addModalData.sendtm);
    // fd.append("send_trackingcode", "1212");
    fd.append("type", "1");
    fd.append("order_type", "1");
    fd.append("deleted_order_items_ids", deletedOrderId.toString());

    for (let i = 0; i < addModalData.addDevice.length; i++) {
      fd.append(`order_items[${i}][title]`, addModalData.addDevice[i].title);
      fd.append(
        `order_items[${i}][main_price]`,
        addModalData.addDevice[i].main_price
      );
      fd.append(
        `order_items[${i}][discount]`,
        addModalData.addDevice[i].main_discount
      );
      fd.append(
        `order_items[${i}][description]`,
        addModalData.addDevice[i].description
      );
      fd.append(`order_items[${i}][number]`, addModalData.addDevice[i].number);
      if (addModalData.addDevice[i].choseFile) {
        fd.append(`file_${i}`, addModalData.addDevice[i].choseFile);
      } else {
        fd.append(`file_${i}`, addModalData.addDevice[i].url);
      }
      // }
    }
    sendRequest2("edit_repair_order_new", fd).then(({ data }) => {
      if (data.status == 200) {
        toast.success("تعمیر با موفقیت ویرایش شد.");
        document.querySelector("#UpdateRepairModal.btn-close").click();
        orderUpdater(prev => {
          return !prev;
        });
      } else {
        toast.error("مشکلی در ویرایش تعمیر پیش آمده است.");
      }
      console.log("data", data);
    });
  };
  // const RemoveText = (index) => {
  //   let newArray = addModalData.addDevice.filter((value, index2, array) => {
  //     if (index == index2) {
  //       return false;
  //     } else {
  //       return true;
  //     }
  //   });
  //   setAddModalData((prev)=>{return {...prev,addDevice:[...newArray]}});
  // };
  const phoneNumberValidation = phone => {
    return /^09\d{9}$/.test(phone);
  };
  const Validation = () => {
    let temp = true;
    if (phoneNumberValidation(addModalData.userName.phoneNumber)) {
      setValidateValues(prev => {
        return { ...prev, phoneNumber: true };
      });
    } else {
      temp = false;
      setValidateValues(prev => {
        return { ...prev, phoneNumber: false };
      });
    }
    if (addModalData.addDevice.length > 0) {
      setValidateValues(prev => {
        return { ...prev, addDevice: true };
      });
    } else {
      setValidateValues(prev => {
        return { ...prev, addDevice: false };
      });

      temp = false;
    }
    if (addModalData.userName) {
      setValidateValues(prev => {
        return { ...prev, userName: true };
      });
    } else {
      temp = false;

      setValidateValues(prev => {
        return { ...prev, userName: false };
      });
    }
    if (addModalData.sendtm != "") {
      setValidateValues(prev => {
        return { ...prev, sendtm: true };
      });
    } else {
      setValidateValues(prev => {
        return { ...prev, sendtm: false };
      });
    }
    return true;
  };

  const ValidationDetailsRepair = () => {
    let isValidate = true;
    // console.log("temp value", tempValue);
    if (tempValue.title) {
      setTempValidateValues(prev => {
        return { ...prev, title: true };
      });
    } else {
      setTempValidateValues(prev => {
        return { ...prev, title: false };
      });
      isValidate = false;
    }
    if (tempValue.main_discount > 0) {
      setTempValidateValues(prev => {
        return { ...prev, main_discount: true };
      });
    } else {
      setTempValidateValues(prev => {
        return { ...prev, main_discount: false };
      });
      isValidate = false;
    }
    //  if (tempValue.choseFile) {
    //     setTempValidateValues((prev) => {
    //       return { ...prev, choseFile: true };
    //     });
    //   } else {
    //     setTempValidateValues((prev) => {
    //       return { ...prev, choseFile: false };
    //     });
    //     isValidate = false;
    //   }
    if (tempValue.desc) {
      setTempValidateValues(prev => {
        return { ...prev, desc: true };
      });
    } else {
      setTempValidateValues(prev => {
        return { ...prev, desc: false };
      });
      isValidate = false;
    }
    if (tempValue.number) {
      setTempValidateValues(prev => {
        return { ...prev, number: true };
      });
    } else {
      setTempValidateValues(prev => {
        return { ...prev, number: false };
      });
      isValidate = false;
    }

    if (parseInt(tempValue.main_price) > parseInt(tempValue.main_discount)) {
      setTempValidateValues(prev => {
        return { ...prev, main_price: true };
      });
    } else {
      setTempValidateValues(prev => {
        return { ...prev, main_price: false };
      });
      isValidate = false;
    }
    return isValidate;
  };

  const [validateValues, setValidateValues] = useState({
    userName: true,
    phoneNumber: true,
    totalPrice: true,
    DateReceived: true,
    trackingN: true,
    debtAmount: true,
    sendtm: true,
    addDevice: true
  });
  const [tempValidateValues, setTempValidateValues] = useState({
    title: true,
    main_price: true,
    main_discount: true,
    choseFile: true,
    desc: true,
    number: true
  });
  console.log("tempValidateValues", tempValidateValues);
  useEffect(() => {
    console.log("selected items", selectedItem);
    setAddModalData({
      ...selectedItem,
      // sendtm: selectedItem.sendtm * 1000,
      addDevice: selectedItem.items,
      totalPrice: +selectedItem.items?.reduce((total, currentValue) => {
        return (
          total +
          (currentValue.main_price - currentValue.main_discount) *
            (currentValue.number ? currentValue.number : 1)
        );
      }, 0),
      userName: {
        value: selectedItem.id,
        label:
          selectedItem.user_muid?.fname + " " + selectedItem.user_muid?.lname,
        phoneNumber: selectedItem.user_muid?.mobile
      }
    });
  }, [selectedItem]);
  const [tempValue, setTempValue] = useState({
    title: "",
    main_price: "",
    id: 0,
    main_discount: "",
    desc: "",
    choseFile: "",
    number: ""
  });
  const RemoveCounter = index => {
    let newArray = addModalData.addDevice?.filter((value, index2, array) => {
      if (index == index2) {
        console.log("value", value);
        setDeletedOrderId(prev => {
          return [...prev, value.id];
        });
        console.log("deletedOrderId in filter", deletedOrderId);
        return false;
      } else {
        return true;
      }
    });
    setAddModalData(prev => {
      return { ...prev, addDevice: [...newArray] };
    });
  };

  const modalVar = (
    <div
      className="modal fade addOrder"
      id="UpdateRepairModal"
      tabIndex={-1}
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg">
        {Object.keys(selectedItem).length && (
          <div
            className="modal-content"
            style={{
              backgroundColor: "white",
              borderRadius: "15px",
              padding: "30px"
            }}
          >
            <div class="modal-header">
              <h5 class="modal-title"> ویرایش تعمیرات</h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row order-item2">
                <form action="#" data-parsley-validate noValidate>
                  <div className="d-flex ">
                    <div
                      style={{
                        backgroundColor: "#203b8c",
                        width: "200px",
                        borderRadius: "30px 0px 0px 30px",
                        marginTop: "20px",
                        paddingRight: "4px"
                      }}
                    >
                      <p
                        style={{
                          marginTop: "10px",
                          color: "white"
                        }}
                      >
                        مشخصات کاربر :
                      </p>
                    </div>
                  </div>
                  <div
                    className="row pt-3"
                    style={{
                      borderBottom: "1px solid #dee2e6",
                      borderRight: "1px solid #dee2e6",
                      marginTop: "20px",
                      marginRight: "20px"
                    }}
                  >
                    <div className="col-12 col-lg-6 d-flex  mt-2 container-responsive">
                      <div
                        className="label"
                        style={{
                          width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="name-us"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          نام کاربر:
                        </label>
                      </div>

                      <div
                        className="input"
                        style={{ direction: "rtl", width: "75%" }}
                      >
                        {`${selectedItem.user_muid.fname} ${selectedItem.user_muid.lname}`}

                        {/* <Creatable
                          options={userOption}
                          // isMulti
                          id="name-us"
                          value={addModalData.userName}
                          onChange={(value) => {
                            changeHandler(value, "userName");
                            if (value.value == "create") {
                              setDisplayStatus("d-block");
                            } else {
                              setDisplayStatus("d-none");
                            }
                          }}
                        /> */}

                        {/* <input
                          type="text"
                          name="user_muid"
                          id="name-us"
                          parsley-trigger="change"
                          className="form-control"
                          value={`${selectedItem.user_muid.fname} ${selectedItem.user_muid.lname}`}
                          onChange={(e) => {
                            changeHandler(e.target.value, "user_muid");
                          }}
                        /> */}
                        {/* <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility: validateValues.NameUser
                              ? "visible"
                              : "hidden",
                          }}
                        >
                          لطفا نام کاربر را وارد کنید.
                        </p> */}
                      </div>
                    </div>
                    <div className="col-12 col-lg-6 d-flex  mt-2 container-responsive">
                      <div
                        className="label"
                        style={{
                          width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="phone-Number"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          موبایل :
                        </label>
                      </div>

                      <div
                        className="input"
                        style={{ direction: "rtl", width: "75%" }}
                      >
                        {/* {console.log("addModalData.userName", addModalData)} */}
                        {`${selectedItem.user_muid.mobile}`}
                        {/* <input
                          type="text"
                          name="user_muid"
                          required
                          className="form-control"
                          id="phone_Number"
                          value={addModalData.userName.phoneNumber}
                          onChange={(e) => {
                            if (
                              addModalData.userName.__isNew__ &&
                              !isNaN(e.target.value)
                            ) {
                              setAddModalData((prev) => {
                                return {
                                  ...prev,
                                  userName: {
                                    ...prev.userName,
                                    phoneNumber: e.target.value,
                                  },
                                };
                              });
                            }
                          }}
                        /> */}
                        {/* <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility: validateValues.phone
                              ? "visible"
                              : "hidden",
                          }}
                        >
                          لطفا موبایل را وارد کنید.
                        </p> */}
                      </div>
                    </div>
                    {/* ایجادکاربر جدید */}
                    <div
                      className={`d-flex ${displayStatus} rounded`}
                      style={{ border: "1px dashed lightgray" }}
                    >
                      <div className="w-50 p-1">
                        <label>نام کاربر:</label>
                        <input
                          className="form-control"
                          type="text"
                          value={newUser.fName}
                          onChange={e => {
                            setNewUser(prev => {
                              return { ...prev, fName: e.target.value };
                            });
                          }}
                        ></input>
                      </div>
                      <div className="w-50 p-1">
                        <label>فامیل کاربر:</label>
                        <input
                          className="form-control"
                          type="text"
                          value={newUser.lName}
                          onChange={e => {
                            setNewUser(prev => {
                              return { ...prev, lName: e.target.value };
                            });
                          }}
                        ></input>
                      </div>
                      <div className="w-50 p-1">
                        <label>موبایل کاربر:</label>
                        <input
                          className="form-control"
                          type="text"
                          value={newUser.mobile}
                          onChange={e => {
                            setNewUser(prev => {
                              return { ...prev, mobile: e.target.value };
                            });
                          }}
                        ></input>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex ">
                    <div
                      style={{
                        backgroundColor: "#203b8c",
                        width: "200px",
                        borderRadius: "30px 0px 0px 30px",
                        marginTop: "20px",
                        paddingRight: "4px"
                      }}
                    >
                      <p
                        style={{
                          marginTop: "10px",
                          color: "white"
                        }}
                      >
                        مشخصات گیرنده :
                      </p>
                    </div>
                  </div>
                  <div
                    className="row pt-3"
                    style={{
                      borderBottom: "1px solid #dee2e6",
                      borderRight: "1px solid #dee2e6",
                      marginTop: "20px",
                      marginRight: "20px",
                      paddingBottom: "30px"
                    }}
                  >
                    <div className="col-12 col-lg-6 d-flex container-responsive  mt-2">
                      <div
                        className="label"
                        style={{
                          // width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="rescipient_fname"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          نام گیرنده:
                        </label>
                      </div>

                      <div
                        className="input"
                        style={{
                          direction: "rtl" //width: "75%"
                        }}
                      >
                        <input
                          type="text"
                          required
                          name="rescipient_fname"
                          className="form-control"
                          id="rescipient_fname"
                          value={addModalData.rescipient_fname}
                          onChange={e => {
                            changeHandler(e.target.value, "rescipient_fname");
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-lg-6 d-flex container-responsive mt-2">
                      <div
                        className="label"
                        style={{
                          // width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="rescipient_lname"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          فامیلی گیرنده :
                        </label>
                      </div>

                      <div
                        className="input"
                        style={{
                          direction: "rtl" //width: "75%"
                        }}
                      >
                        <input
                          type="text"
                          required
                          name="rescipient_lname"
                          className="form-control"
                          id="rescipient_lname"
                          value={addModalData.rescipient_lname}
                          onChange={e => {
                            changeHandler(e.target.value, "rescipient_lname");
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-lg-6 d-flex container-responsive  mt-4">
                      <div
                        className="label"
                        style={{
                          //width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="rescipient_mobile"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          موبایل گیرنده :
                        </label>
                      </div>

                      <div
                        className="input"
                        style={{
                          direction: "rtl" //width: "75%"
                        }}
                      >
                        <input
                          type="text"
                          required
                          name="rescipient_mobile"
                          className="form-control"
                          id="rescipient_mobile"
                          value={addModalData.rescipient_mobile}
                          onChange={e => {
                            changeHandler(e.target.value, "rescipient_mobile");
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-lg-6 d-flex container-responsive  mt-4">
                      <div
                        className="label"
                        style={{
                          //width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="rescipient_postalcode"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          کدپستی گیرنده :
                        </label>
                      </div>

                      <div
                        className="input"
                        style={{
                          direction: "rtl" //width: "75%"
                        }}
                      >
                        <input
                          type="text"
                          required
                          name="rescipient_postalcode"
                          className="form-control"
                          id="rescipient_postalcode"
                          value={addModalData.rescipient_postalcode}
                          onChange={e => {
                            changeHandler(
                              e.target.value,
                              "rescipient_postalcode"
                            );
                          }}
                        />
                      </div>
                    </div>
                    <div className=" col-12 d-flex my-3 container-responsive">
                      <div
                        className="labelReceptor"
                        style={{
                          // width: "17%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="address"
                          style={{
                            color: "#707070",
                            whiteSpace: "nowrap"
                          }}
                        >
                          آدرس گیرنده :
                        </label>
                      </div>

                      <div
                        className="inputReceptor"
                        style={{
                          direction: "rtl"
                          // width: "83%",
                        }}
                      >
                        <textarea
                          type="text"
                          required
                          className="form-control "
                          id="address"
                          name="rescipient_address"
                          value={addModalData.rescipient_address}
                          onChange={e => {
                            changeHandler(e.target.value, "rescipient_address");
                          }}
                        />

                        {/* <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility:
                            validateValues.address == "" ? "visible" : "hidden",
                        }}
                      >
                        لطفا آدرس را وارد کنید .
                      </p> */}
                      </div>
                    </div>
                  </div>
                  <div className="d-flex ">
                    <div
                      style={{
                        backgroundColor: "#203b8c",
                        width: "200px",
                        borderRadius: "30px 0px 0px 30px",
                        marginTop: "20px",
                        paddingRight: "4px"
                      }}
                    >
                      <p
                        style={{
                          marginTop: "10px",
                          color: "white"
                        }}
                      >
                        مشخصات تعمیر :
                      </p>
                    </div>
                  </div>
                  <div
                    className="row pt-3"
                    style={{
                      borderBottom: "1px solid #dee2e6",
                      borderRight: "1px solid #dee2e6",
                      marginTop: "20px",
                      marginRight: "20px"
                    }}
                  >
                    <div className="col-12 col-lg-6 d-flex  mt-2 container-responsive">
                      <div
                        className="label"
                        style={{
                          width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="Date-Received"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          تاریخ ارسال:
                        </label>
                      </div>

                      <div
                        className="input"
                        style={{ direction: "rtl", width: "75%" }}
                      >
                        {/* {console.log("sendtm", addModalData)} */}
                        <DatePicker
                          calendar={persian}
                          locale={persian_fa}
                          id="Date-Received"
                          inputClass={"date-picker-style form-control"}
                          calendarPosition="bottom-right"
                          value={+addModalData.sendtm * 1000}
                          onChange={e => {
                            setAddModalData(prev => {
                              return { ...prev, sendtm: e.unix };
                            });
                          }}
                        />
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility: !validateValues.sendtm
                              ? "visible"
                              : "hidden"
                          }}
                        >
                          لطفا تاریخ ارسال را وارد کنید.
                        </p>
                      </div>
                    </div>
                    <div className="col-12 col-lg-6 d-flex  mt-2 container-responsive">
                      <div
                        className="label"
                        style={{
                          width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="total-Price"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          مبلغ کل :
                        </label>
                      </div>

                      <div
                        className="input"
                        style={{ direction: "rtl", width: "75%" }}
                      >
                        {console.log("selectedItem", addModalData)}
                        <input
                          type="text"
                          name="price"
                          id="total-Price"
                          parsley-trigger="change"
                          className="form-control"
                          value={addCommas(
                            addModalData.addDevice?.reduce(
                              (total, currentValue) => {
                                return currentValue.number == undefined
                                  ? total +
                                      (currentValue.main_price -
                                        currentValue.main_discount) *
                                        currentValue.itemcount
                                  : total +
                                      (currentValue.main_price -
                                        currentValue.main_discount) *
                                        currentValue.number;
                              },
                              0
                            )
                          )}
                          onChange={e => {
                            changeHandler(e.target.value, "Price");
                          }}
                        />

                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility: validateValues.Price
                              ? "visible"
                              : "hidden"
                          }}
                        ></p>
                      </div>
                    </div>
                    <div className="col-12 col-lg-6 d-flex  mt-2 container-responsive">
                      <div
                        className="label"
                        style={{
                          width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="paidAmount"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          مبلغ پرداخت شده :
                        </label>
                      </div>

                      <div
                        className="input"
                        style={{ direction: "rtl", width: "75%" }}
                      >
                        <input
                          type="text"
                          name="paid_amount"
                          id="paidAmount"
                          parsley-trigger="change"
                          className="form-control"
                          value={addCommas(addModalData.paid_amount)}
                          // onChange={(e) => {
                          //   if (!isNaN(e.target.value))
                          //     changeHandler(e.target.value, "paid_amount");
                          // }}
                          readOnly
                        />
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px"
                          }}
                        ></p>
                      </div>
                    </div>
                    <div className="col-12 col-lg-6 d-flex  mt-2 container-responsive">
                      <div
                        className="label"
                        style={{
                          width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="debt-Amount"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          مانده حساب :
                        </label>
                      </div>

                      <div
                        className="input"
                        style={{ direction: "rtl", width: "75%" }}
                      >
                        <input
                          type="text"
                          id="debt-Amount"
                          name="debtAmount"
                          parsley-trigger="change"
                          className="form-control"
                          value={addCommas(
                            addModalData.totalPrice -
                              selectedItem.total_discount
                          )}
                          // onChange={(e) => {
                          //   if (!isNaN(e.target.value))
                          //     changeHandler(e.target.value, "debtAmount");
                          // }}
                          readOnly
                        />
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px"
                          }}
                        ></p>
                      </div>
                    </div>
                    <div className="col-12 col-lg-6 d-flex  mt-2 container-responsive">
                      <div
                        className="label"
                        style={{
                          width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="TrackingCode"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          شماره پیگیری :
                        </label>
                      </div>

                      <div
                        className="input"
                        style={{ direction: "rtl", width: "75%" }}
                      >
                        <input
                          type="text"
                          name="send_trackingcode"
                          id="TrackingCode"
                          parsley-trigger="change"
                          className="form-control"
                          value={addModalData.send_trackingcode}
                          readOnly

                          // onChange={(e) => {
                          //   if (!isNaN(e.target.value))
                          //     changeHandler(
                          //       e.target.value,
                          //       "send_trackingcode"
                          //     );
                          // }}
                        />
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px"
                          }}
                        ></p>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex">
                    <div
                      style={{
                        backgroundColor: "#203b8c",
                        width: "200px",
                        borderRadius: "30px 0px 0px 30px",
                        paddingRight: "5px",
                        marginTop: "20px"
                      }}
                    >
                      <p
                        style={{
                          marginTop: "10px",
                          color: "white"
                        }}
                      >
                        دستگاه:
                      </p>
                    </div>
                    <button
                      style={{
                        height: "30px",
                        marginTop: "25px",
                        marginRight: "5px",
                        backgroundColor: "white",
                        border: "none",
                        fontSize: "20px"
                      }}
                      type="button"
                      onClick={() => {
                        setTempValue({
                          title: "",
                          main_price: "",
                          id: 0,
                          main_discount: "",
                          desc: "",
                          choseFile: "",
                          number: ""
                        });
                        if (ValidationDetailsRepair()) {
                          setAddModalData(prev => {
                            return {
                              ...prev,
                              addDevice: [
                                ...addModalData.addDevice,
                                {
                                  // main_discount: tempValue.Discount,
                                  // main_price: tempValue.price,
                                  // description: tempValue.desc,
                                  // title: tempValue.title,
                                  main_discount: tempValue.main_discount,
                                  main_price: tempValue.main_price,
                                  description: tempValue.desc,
                                  title: tempValue.title,
                                  choseFile: tempValue.choseFile,
                                  number: tempValue.number
                                }
                              ]
                            };
                          });
                        }
                      }}
                    >
                      <FcPlus></FcPlus>
                    </button>
                  </div>

                  <div
                    className="row pt-3"
                    style={{
                      borderBottom: "1px solid #dee2e6",
                      borderRight: "1px solid #dee2e6",
                      marginTop: "20px",
                      marginRight: "20px"
                    }}
                  >
                    <div className="col-12 col-lg-6 d-flex  mt-2 container-responsive">
                      <div
                        className="label"
                        style={{
                          width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="title"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          عنوان :
                        </label>
                      </div>

                      <div
                        className="input"
                        style={{ direction: "rtl", width: "75%" }}
                      >
                        <input
                          type="text"
                          required
                          className="form-control"
                          id="title"
                          name="title"
                          value={tempValue.title}
                          onChange={e => {
                            setTempValue(prev => {
                              return { ...prev, title: e.target.value };
                            });
                          }}
                        />
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility: !tempValidateValues.title
                              ? "visible"
                              : "hidden"
                          }}
                        >
                          لطفا عنوان را وارد کنید.
                        </p>
                      </div>
                    </div>
                    <div className="col-12 col-lg-6 d-flex mt-2 container-responsive">
                      <div
                        className="label"
                        style={{
                          width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="price"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          مبلغ :
                        </label>
                      </div>
                      {console.log("tempValue", tempValue)}
                      <div
                        className="input"
                        style={{ direction: "rtl", width: "75%" }}
                      >
                        <input
                          type="text"
                          required
                          name="main_price"
                          className="form-control"
                          id="price"
                          value={addCommas(tempValue.main_price)}
                          onChange={e => {
                            setTempValue(prev => {
                              return {
                                ...prev,
                                main_price: removeCommas(e.target.value)
                              };
                            });
                          }}
                        />
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility: !tempValidateValues.main_price
                              ? "visible"
                              : "hidden"
                          }}
                        >
                          لطفا مبلغ را وارد کنید.
                        </p>
                      </div>
                    </div>

                    <div className="col-12 col-lg-6 d-flex container-responsive mt-2">
                      <div
                        className="label"
                        style={{
                          // width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="number"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          تعداد :
                        </label>
                      </div>

                      <div
                        className="input"
                        style={{
                          direction: "rtl"
                          // width: "65%",
                        }}
                      >
                        <input
                          type="text"
                          name="number"
                          required
                          className="form-control"
                          id="number"
                          value={tempValue.number}
                          onChange={e => {
                            setTempValue(prev => {
                              return {
                                ...prev,
                                number: e.target.value
                              };
                            });
                          }}
                        />

                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility: !tempValidateValues.number
                              ? "visible"
                              : "hidden"
                          }}
                        >
                          لطفا تعداد را وارد کنید.
                        </p>
                      </div>
                    </div>
                    <div className="col-12 col-lg-6 d-flex  mt-2 container-responsive">
                      <div
                        className="label"
                        style={{
                          width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="Discount"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          مبلغ با تخفیف :
                        </label>
                      </div>

                      <div
                        className="input"
                        style={{ direction: "rtl", width: "75%" }}
                      >
                        <input
                          type="text"
                          required
                          className="form-control"
                          id="Discount"
                          name="main_discount"
                          value={addCommas(tempValue.main_discount)}
                          onChange={e => {
                            if (
                              removeCommas(e.target.value) >=
                              tempValue.main_price
                            ) {
                              toast.error(
                                "مبلغ تخفیف نمی تواند بیشتر از قیمت کل باشد!"
                              );
                            } else {
                              setTempValue(prev => {
                                return {
                                  ...prev,
                                  main_discount: removeCommas(e.target.value)
                                };
                              });
                            }
                          }}
                        />
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility: !tempValidateValues.main_discount
                              ? "visible"
                              : "hidden"
                          }}
                        >
                          لطفا مبلغ با تخفیف را وارد کنید.
                        </p>
                      </div>
                    </div>
                    <div className="col-12 col-lg-6 d-flex  mt-2 container-responsive">
                      <div
                        className="label"
                        style={{
                          width: "35%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="choseFile"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          انتخاب فایل :
                        </label>
                      </div>

                      <div
                        className="input"
                        style={{ direction: "rtl", width: "75%" }}
                      >
                        <input
                          className="form-control"
                          type="file"
                          id="choseFile"
                          name="choseFile"
                          value={tempValue.choseFile.value}
                          onChange={e => {
                            setTempValue(prev => {
                              return {
                                ...prev,
                                choseFile: e.target.files[0]
                              };
                            });
                          }}
                        />
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px"
                            // visibility: !tempValidateValues.choseFile
                            //   ? "visible"
                            //   : "hidden",
                          }}
                        >
                          {/* لطفاتصویر مورد نطر وارد کنید. */}
                        </p>
                      </div>
                    </div>
                    <div className="col-12 col-lg-12 d-flex container-responsive mt-2">
                      <div
                        className="labelAddress"
                        style={{
                          width: "18%",
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="desc"
                          style={{
                            color: "#707070",
                            whiteSpace: "nowrap",
                            fontSize: "14px"
                          }}
                        >
                          توضیحات :
                        </label>
                      </div>
                      <div
                        className="inputAddress"
                        style={{
                          direction: "rtl",
                          width: "100%"
                        }}
                      >
                        <textarea
                          required
                          className="form-control"
                          id="desc"
                          value={tempValue.desc}
                          onChange={e => {
                            setTempValue(prev => {
                              return { ...prev, desc: e.target.value };
                            });
                          }}
                        />
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility: !tempValidateValues.desc
                              ? "visible"
                              : "hidden"
                          }}
                        >
                          لطفا توضیحات را وارد کنید.
                        </p>
                      </div>
                    </div>
                    <p
                      style={{
                        fontSize: "12px",
                        color: "red",
                        visibility:
                          validateValues.addDevice == "" ? "visible" : "hidden"
                      }}
                    >
                      لیست دستگاهای تعمیر نباید خالی باشد.
                    </p>
                    <div
                      className="row pt-3"
                      style={{
                        // borderBottom: "1px solid #dee2e6",
                        // borderRight: "1px solid #dee2e6",
                        marginTop: "20px"
                      }}
                    >
                      <div className=" col-12 col-lg-12 d-flex mt-2 container-responsive">
                        <div
                          className="labelAddress"
                          style={{
                            width: "20%",
                            textAlign: "right",
                            marginTop: "5px"
                          }}
                        ></div>
                      </div>
                      {addModalData.addDevice?.map((value, index) => {
                        return (
                          <div
                            className="row pt-3 mt-4"
                            style={{
                              //borderBottom: "1px solid #dee2e6",
                              marginBottom: "15px",
                              marginRight: "5px"
                            }}
                          >
                            <div className="col-12 col-lg-1">
                              {value.choseFile && value.choseFile != "" ? (
                                <>
                                  <img
                                    src={URL.createObjectURL(value.choseFile)}
                                    style={{
                                      width: "50px",
                                      height: "50px",
                                      border: "1px solid #F5F5F5"
                                    }}
                                  />
                                </>
                              ) : (
                                <img
                                  src={staticImg.imgl1}
                                  style={{
                                    width: "50px",
                                    height: "50px",
                                    border: "1px solid #F5F5F5"
                                  }}
                                />
                              )}
                            </div>
                            <div className="box-txt col-10 ">
                              <p
                                style={{
                                  fontSize: "13px",
                                  marginTop: "15px",
                                  marginRight: "10px"
                                }}
                              >
                                دستگاهی با عنوان:
                                <span
                                  style={{
                                    marginRight: "5px",
                                    marginLeft: "5px",
                                    color: "red"
                                  }}
                                >
                                  {value.title}
                                </span>
                                به مبلغ:
                                <span
                                  style={{
                                    marginRight: "5px",
                                    marginLeft: "5px",
                                    color: "red"
                                  }}
                                >
                                  {addCommas(value.main_price)}
                                </span>
                                تومان باتعداد :
                                <span
                                  style={{
                                    marginRight: "5px",
                                    marginLeft: "5px",
                                    color: "red"
                                  }}
                                >
                                  {value.number == undefined
                                    ? value.itemcount
                                    : value.number}
                                </span>
                                را به قیمت تخفیف :
                                <span
                                  style={{
                                    marginRight: "5px",
                                    marginLeft: "5px",
                                    color: "red"
                                  }}
                                >
                                  {addCommas(
                                    value.main_price - value.main_discount
                                  )}
                                </span>
                                تومان را با قیمت نهایی :
                                <span
                                  style={{
                                    marginRight: "5px",
                                    marginLeft: "5px",
                                    color: "red"
                                  }}
                                >
                                  {addCommas(
                                    value.number == undefined
                                      ? (value.main_price -
                                          value.main_discount) *
                                          value.itemcount
                                      : (value.main_price -
                                          value.main_discount) *
                                          value.number
                                  )}
                                </span>
                                اضافه کردید.
                              </p>
                            </div>
                            <div
                              className="col-1"
                              style={{ width: "5px", textAlign: "left" }}
                            >
                              <button
                                type="button"
                                style={{
                                  border: "none",
                                  backgroundColor: "#f9f7f8",
                                  backgroundColor: "white",
                                  fontSize: "20px",
                                  marginTop: "15px"
                                }}
                                onClick={() => {
                                  RemoveCounter(index);
                                }}
                              >
                                <HiMinusCircle
                                  style={{ color: "#35b8e0" }}
                                ></HiMinusCircle>
                              </button>
                            </div>
                            <div className="parent">
                              <div
                                className="col-12 col-lg-2"
                                style={{ width: "12%", marginTop: "10px" }}
                              >
                                <label
                                  style={{
                                    color: "#707070",
                                    whiteSpace: "nowrap",
                                    fontWeight: "bold",
                                    fontSize: "15px"
                                  }}
                                >
                                  توضیحات:
                                </label>
                              </div>
                              <div
                                className="col-12 col-lg-10 flex-wrap"
                                style={{
                                  width: "85%",
                                  marginTop: "13px",
                                  flex: "wrap"
                                }}
                              >
                                <p
                                  style={{
                                    color: "#707070",
                                    whiteSpace: "nowrap",
                                    fontSize: "13px"
                                  }}
                                >
                                  {value.description == undefined
                                    ? value.description
                                    : value.description}
                                </p>
                              </div>
                            </div>

                            {/* <div
                              style={{
                                borderBottom: "1px solid #dee2e6",
                                height: "3px",
                                marginRight: "5px",
                              }}
                            ></div> */}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="d-flex justify-content-end mt-2">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  if (Validation() && addModalData.addDevice != "") {
                    sendAddModalData();
                  }
                  //console.log("vali:", sendAddModalData());
                }}
              >
                ویرایش
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );

  return createPortal(modalVar, document.querySelector("#modals"));
}
